import { revertIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Revert = createIcon({
  displayName: 'Revert',
  paths: [
    'M212.89 286.144c0-23.595 19.115-42.667 42.667-42.667s42.667 19.072 42.667 42.667v18.475c13.739-14.165 28.715-27.563 45.824-39.381 98.9-68.437 233.642-69.333 333.183-1.877 176.043 119.296 177.877 372.181 5.547 494.293-94.123 66.688-222.379 71.509-321.578 12.672-41.557-24.619-73.728-56.32-97.493-92.032-14.293-21.461-4.608-50.901 18.901-61.611 19.413-8.832 41.813-1.707 53.632 16.085 17.877 26.923 42.709 50.56 76.715 67.797 74.666 37.973 167.764 30.805 232.831-21.931 112.939-91.52 105.472-268.288-22.485-348.501-57.771-36.181-131.84-40.832-194.432-13.909-31.871 13.653-56.49 33.024-76.074 55.253h30.763c23.552 0 42.667 19.072 42.667 42.667s-19.115 42.667-42.667 42.667h-128c-11.776 0-22.443-4.779-30.165-12.501s-12.501-18.389-12.501-30.165v-128z'
  ],
  canvasPaths: canvasIconPaths(revertIcon)
})
